import { HttpService, Repository, RepositoryBase, TaggedUrl, Tags, Weaver } from '@skylab-shared/core';
import { CountryModel } from '@skylab-shared/dataModel';
import { pickBy } from '@skylab-shared/utils';
import { CountryBO } from './country.bo';

@Repository({
    boType: CountryBO,
    apiController: TaggedUrl.join('system/countries', [Tags.Api])
})
export class CountryRepositoryBase extends RepositoryBase<CountryBO, CountryModel> {
    public constructor(
        http: HttpService,
        private readonly weaver: Weaver
    ) {
        super(http);
    }

    protected createBO(): CountryBO {
        return new CountryBO(this.weaver);
    }

    protected async preparePlainObjectAsync(model: CountryModel): Promise<any> {
        return {
            id: model.id,
            version: model.version,
            sun: model.sun,

            code: model.code,
            default: model.default,
            euMember: model.euMember,
            name: model.name,
            externalId: model.externalId
        };
    }

    protected async fromPlainObjectAsync(item: any): Promise<CountryModel> {
        return new CountryModel(pickBy({
            id: item.id,
            version: item.version,
            sun: item.sun,

            code: item.code,
            default: item.default,
            euMember: item.euMember,
            name: item.name,
            externalId: item.externalId
        }, val => val !== void 0));
    }
}
